const deliveryMethod = {
    email: 'email',
    delivery: 'delivery'
};

export default deliveryMethod;